<template>
<div class="chapter">
<div class="inner_page">
<h1 id="toc" title="Copyright"></h1>
<p class="first" id="Copyright">InterVarsity Press<br/>
  P.O. Box 1400<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank">www.ivpress.com</a><br/>
  E-mail: <a href="mailto:email@ivpress.com">email@ivpress.com</a></p>
<p class="first">© 2011 Simon Vibert</p>
<p class="first">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="first">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank">www.intervarsity.org</a>.</p>
<p class="first">All Scripture quotations, unless otherwise indicated, are taken from the <em>Holy Bible, New International Version®. NIV</em>®. Copyright ©1973, 1978, 1984 by International Bible Society. Used by permission of Hodder and Stoughton Ltd. All rights reserved. “NIV” is a registered trademark of International Bible Society. UK trademark number 1448790. Distributed in North America by permission of Zondervan Publishing House.</p>
<p class="first">While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.</p>
<p class="first">Cover design: Cindy Kiple Interior design: Beth Hagenberg Images: John Piper: Bethlehem Baptist Church Nicky Gumbel: HTB /Alpha International, London, England John Ortberg: Jeanne dePolo Photography, Redwood City, CA &gt;Tim Keller: Redeemer Presbyterian Churchs</p>
<p class="first">ISBN 978-0-8308-6382-2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CopyrightPage.vue?ef20579c